const colorPallette = ['#FFB1B4', '#E9B189', '#E9D087', '#B3CBB9', '#BFD7EA', '#CFBCE7', '#eed7a1', '#8a8583']

const standartDateFormat = 'MMM D, YY'

export { colorPallette, standartDateFormat }
